import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    modalPage: {
      position: 'fixed',
      left: '20%',
      top: 0,
      opacity: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: theme.semanticColors.inputBackground,
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      transition: 'left 0.2s, opacity 0.2s',
      '&.appeared': {
        left: 0,
        opacity: 1,
      }
    },
    header: {
      display: 'flex',
      fontSize: '20px',
      fontWeight: 300,
      padding: '8px',
      borderBottom: `1px solid ${theme.semanticColors.disabledBorder}`,
    },
    topPanel: {
      display: 'flex',
      padding: '10px 16px 10px 12px',
      '& .select-all': {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '4px',
        ':hover': {
          backgroundColor: theme.semanticColors.buttonBackgroundHovered,
        }
      }
    },
    bottomPanel: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '16px',
      borderTop: `1px solid ${theme.semanticColors.disabledBorder}`,
      '& .applyButton': {
        flex: '1 1 auto',
        maxWidth: '450px',
      },
      '& .toggleContainer': {
        display: 'flex',
        alignItems: 'center',
        flex: '0 0 fit-content',
        gap: '4px',
        '& .controlLabel': {
          color: theme.semanticColors.inputText,
        },
        '& .ms-Toggle': {
          marginBottom: 0,
        }
      },
      padding: '10px 12px',
    },
  })
};
